"use client";

import { useTranslations } from "next-intl";

import { cn } from "@/lib/utils/cn";

interface ReadingTimeProps {
  minutes: number;
  className?: string;
}

export function ReadingTime({ minutes, className }: ReadingTimeProps) {
  const t = useTranslations("pages.articles");
  const safeMinutes = Math.max(1, Math.round(minutes));
  return (
    <span className={cn("text-sm text-muted-foreground", className)}>
      {t("readingTime", { minutes: safeMinutes })}
    </span>
  );
}
